var _path, _path2, _path3, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUsersIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M46 13.3722V32.6278C46 41.0021 40.9998 46 32.6278 46H13.3722C5.0002 46 0 41.0021 0 32.6278V13.3722C0 4.9979 5.0002 0 13.3722 0H32.6278C40.9998 0 46 4.9979 46 13.3722Z",
    fill: "url(#paint0_linear_3184_3048)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.8444 23.0107H25.4369C29.2181 23.0107 32.2812 26.0739 32.2812 29.8551V31.8056C32.2812 33.4014 30.9868 34.6958 29.391 34.6958H16.8902C15.2944 34.6958 14 33.4014 14 31.8056V29.8551C14 26.0739 17.0631 23.0107 20.8444 23.0107Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23.1393 21.7435C25.8299 21.7435 28.0111 19.5623 28.0111 16.8717C28.0111 14.1812 25.8299 12 23.1393 12C20.4487 12 18.2676 14.1812 18.2676 16.8717C18.2676 19.5623 20.4487 21.7435 23.1393 21.7435Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3184_3048",
    x1: 8.91896,
    y1: 47.0723,
    x2: 43.5,
    y2: -3,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0105699,
    stopColor: "#A80BAB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#557EE9"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsersIcon);
export default __webpack_public_path__ + "static/media/UsersIcon.6f9291c10f693b1ae85dc8993b7b42fc.svg";
export { ForwardRef as ReactComponent };